/* eslint-disable react/destructuring-assignment,react/button-has-type,react/no-array-index-key,react/require-default-props,react/default-props-match-prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Spinner } from '../../Spinner/Spinner';

export const ModalFooter = (props) => {
  const leftButtons = props.actions
    ? props.actions.filter((action) => action.left)
    : [];

  const rightButtons = props.actions
    ? props.actions.filter((action) => !action.left)
    : [];

  return (
    <div
      className={classNames('react-modal-footer', {
        'react-modal-footer-with-left-buttons': leftButtons.length,
      })}
    >
      {leftButtons.length > 0 && (
        <div className="react-modal-footer-left">
          {leftButtons.map((action, index) => (
            // TODO: Use Button components for buttons
            <button
              key={`buttons-left-${index}`}
              className={`btn btn-${action.type || 'default'}`}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.showSpinner && <Spinner />}
              {action.label}
            </button>
          ))}
        </div>
      )}
      {rightButtons.length > 0 && (
        <div className="react-modal-footer-right">
          {rightButtons.map((action, index) => (
            // TODO: Use Button components for buttons
            <button
              key={`buttons-right-${index}`}
              className={`btn btn-${action.type || 'default'}`}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.showSpinner && <Spinner />}
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

ModalFooter.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func.isRequired,
      type: PropTypes.oneOf([
        'primary',
        'secondary',
        'default',
        'danger',
        'primary-teal',
        'primary-kelp',
      ]),
      showSpinner: PropTypes.bool,
      disabled: PropTypes.bool,
      left: PropTypes.bool,
    })
  ),
};

ModalFooter.defaultProps = {
  showSpinner: false,
  disabled: false,
};
